export enum Statuses {
  Active = "Active",
  Inactive = "Inactive",
}
